import { createFileRoute } from "@tanstack/react-router";
import PoliciesFindingsPage from "../pages/PoliciesFindingsList/PoliciesFindingsPage";

type FindingsSearch = {
  name?: string;
  status?: string;
  category?: string;
};

export const Route = createFileRoute("/_policies/findings")({
  component: PoliciesFindingsPage,
  validateSearch: (search: Record<string, unknown>): FindingsSearch => ({
    name: (search.name as string) || undefined,
    status: (search.status as string) || undefined,
    category: (search.category as string) || undefined,
  }),
});
